import NextLink from 'next/link'
import { type FC } from 'react'

import { type CrossSellProduct } from '@redteclab/api/clients/retail-media-xsell-service'

import { Link, Skeleton } from 'base-ui'

import { useGlobalConfigContext } from '../../../global-config'
import { urlGetRelativeUrl } from '../../../url-handling'
import { crossSellAccessorGetLocalizedProductDeepLink } from '../../model/crossSellAccessorGetLocalizedProductDeepLink'
import { crossSellAccessorGetLocalizedProductName } from '../../model/crossSellAccessorGetLocalizedProductName'

type CrossSellHorizontalSliderItemCompactNameProps = {
  product?: CrossSellProduct
}

export const CrossSellHorizontalSliderItemCompactName: FC<
  CrossSellHorizontalSliderItemCompactNameProps
> = ({ product }) => {
  const { language, tenant } = useGlobalConfigContext()

  if (!product) {
    return <Skeleton className="mb-1 w-full" />
  }

  const productName = crossSellAccessorGetLocalizedProductName({
    language,
    product,
    tenant,
  })

  return (
    <Link<typeof NextLink>
      className="w-full overflow-hidden text-xs font-bold no-underline [-webkit-box-orient:vertical] [-webkit-line-clamp:var(--name-line-clamp)] [display:-webkit-box]"
      color="inherit"
      data-analytics="item-title"
      data-qa-id={`form-product-slider-${product.id}-link-button`}
      href={urlGetRelativeUrl(
        crossSellAccessorGetLocalizedProductDeepLink({
          language,
          product,
          tenant,
        }),
      )}
      slots={{ root: NextLink }}
      title={productName}
    >
      {productName}
    </Link>
  )
}
